import BackupPlanResource from "./backupPlan.resource";

const backupPlanModule = angular
  .module("app.resources.backupPlan", [])
  .service("BackupPlan", BackupPlanResource);

export default backupPlanModule;



// WEBPACK FOOTER //
// ./src/resources/backupPlan/backupPlan.module.js